{
  "title": "위치를 공유하면 체크인 절차를 더 빠르게 진행할 수 있습니다",
  "body": "죄송하지만 위치에 접근할 수 없으면 체크인을 완료할 수 없습니다. 계속하려면 위치 접근 권한을 허용해 주세요. 위치 정보는 창고 체크인 목적으로만 사용되며, 저장하거나 제3자와 공유하지 않습니다.",
  "shareLocation": "내 위치 공유"
}
